import { createSlice } from "@reduxjs/toolkit"

type Agenda = any

interface AgendaState {
    selectedAgendaTab: string
    agendaData: Array<Agenda>
    agendaGroups: Array<any>
    agendaRegions: Array<any>
    agendaOffices: Array<any>
    selectedAgendaGroup: Array<any>
    selectedAgendaRegion: Array<any>
    selectedAgendaOffice: Array<any>
    localActionItems: Array<any>
    actionItems: Array<any>
    selectedViewMeeting: any
    selectedEditMeeting: any
}

const initialState: AgendaState = {
    selectedAgendaTab: "upcoming",
    agendaData: [],
    agendaGroups: [],
    agendaRegions: [],
    agendaOffices: [],
    selectedAgendaGroup: [],
    selectedAgendaRegion: [],
    selectedAgendaOffice: [],
    localActionItems: [],
    actionItems: [],
    selectedViewMeeting: {},
    selectedEditMeeting: {}
}

const agendaSlice = createSlice({
    name: "agenda",
    initialState,
    reducers: {
        setselectedAgendaTab: (state, action) => {
            state.selectedAgendaTab = action.payload;
        },
        setAgendaData: (state, action) => {
            state.agendaData = action.payload;
        },
        setAgendaGroups: (state, action) => {
            state.agendaGroups = action.payload;
        },
        setAgendaRegions: (state, action) => {
            state.agendaRegions = action.payload;
        },
        setAgendaOffices: (state, action) => {
            state.agendaOffices = action.payload;
        },
        setSelectedAgendaGroup: (state, action) => {
            state.selectedAgendaGroup = action.payload;
        },
        setSelectedAgendaRegion: (state, action) => {
            state.selectedAgendaRegion = action.payload;
        },
        setSelectedAgendaOffice: (state, action) => {
            state.selectedAgendaOffice = action.payload;
        },
        setLocalActionItems: (state, action) => {
            state.localActionItems = action.payload;
        },
        updateLocalActionItem: (state, action) => {
            let localArr: any = [];
            state.localActionItems.map((item: any) => {


                if (item?.title == action.payload.title) {
                    item = action.payload.newValues
                }

                localArr.push(item);
            })

            state.localActionItems = localArr
        },
        setActionItems: (state, action) => {
            state.actionItems = action.payload;
        },
        addActionItem: (state, action) => {
            state.localActionItems.push(action.payload);
        },
        removeActionItem: (state, action) => {
            state.localActionItems = state.localActionItems?.filter((item: any) => item.title != action.payload);
        },
        setSelectedViewMeeting: (state, action) => {
            state.selectedViewMeeting = action.payload;
        },
        setSelectedEditMeeting: (state, action) => {
            state.selectedEditMeeting = action.payload;
        },
    }
})

export default agendaSlice.reducer
export const {
    setselectedAgendaTab,
    setSelectedViewMeeting,
    setSelectedEditMeeting,
    setAgendaData,
    setAgendaGroups,
    setAgendaRegions,
    setAgendaOffices,
    setSelectedAgendaGroup,
    setSelectedAgendaRegion,
    setSelectedAgendaOffice,
    setLocalActionItems,
    updateLocalActionItem,
    setActionItems,
    addActionItem,
    removeActionItem
} = agendaSlice.actions;
